import { Alert, AlertTitle, Card, CardContent, CardHeader, FormLabel, Grid, Grid2, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Commons } from "../../helper/CommonService";
import { APP_HOST, TYPE_SEKOLAH_ASAL } from "../../helper/Constant";
import GridForm from "../general/GridForm";
import GridDdlPlace from "../general/GridDdlPlace";

function SekolahAsal({ handleChange, data }) {
    const [isLoadingProvinsi, setIsLoadingProvinsi] = useState(true);
    const [isLoadingKabupaten, setIsLoadingKabupaten] = useState(true);
    const [isLoadingKecamatan, setIsLoadingKecamatan] = useState(true);
    const [isLoadingKelurahan, setIsLoadingKelurahan] = useState(true);
    const [provinsis, setProvinsis] = useState([]);
    const [kabupatens, setKabupatens] = useState([]);
    const [kecamatans, setKecamatans] = useState([]);
    const [kelurahans, setKelurahans] = useState([]);

    const GetKabupaten = (provinsiId) => {
        setIsLoadingKabupaten(true);
        Commons.GetData(APP_HOST + '/alamat/kabupaten-provinsi-' + provinsiId)
            .then((dataResponse) => {
                setKabupatens(dataResponse);
                setKecamatans([]);
                setKelurahans([]);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKabupaten(false);
            });
    }

    const GetKecamatan = (kabupatenId) => {
        setIsLoadingKecamatan(true);
        Commons.GetData(APP_HOST + '/alamat/kecamatan-kabupaten-' + kabupatenId)
            .then((dataResponse) => {
                setKecamatans(dataResponse);
                setKelurahans([]);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKecamatan(false);
            });
    }

    const GetKelurahan = (kecamatanId) => {
        setIsLoadingKelurahan(true);
        Commons.GetData(APP_HOST + '/alamat/kelurahan-kecamatan-' + kecamatanId)
            .then((dataResponse) => {
                setKelurahans(dataResponse);
            })
            .catch((errResponse) => {
                console.log(errResponse);
            })
            .finally(() => {
                setIsLoadingKelurahan(false);
            });
    }

    useEffect(() => {
        setIsLoadingProvinsi(true);
        Commons.GetData(APP_HOST + '/alamat/provinsi')
            .then((dataResponse) => {
                setProvinsis(dataResponse);
                setIsLoadingProvinsi(false);
                setIsLoadingKabupaten(true);
                if (data?.provinsi && data?.kabupaten && data?.kecamatan && data?.kelurahan) {
                    let provinsiId = dataResponse.find((item) => item.nama_provinsi === data.provinsi).id_provinsi;
                    Commons.GetData(APP_HOST + '/alamat/kabupaten-provinsi-' + provinsiId)
                        .then((dataKabupaten) => {
                            setKabupatens(dataKabupaten);
                            setIsLoadingKabupaten(false);
                            setIsLoadingKecamatan(true);
                            let kabupatenId = dataKabupaten.find((item) => item.nama_kabupaten_kota === data.kabupaten).id_kabupaten_kota;
                            Commons.GetData(APP_HOST + '/alamat/kecamatan-kabupaten-' + kabupatenId)
                                .then((dataKecamatan) => {
                                    setKecamatans(dataKecamatan);
                                    setIsLoadingKecamatan(false);
                                    setIsLoadingKelurahan(true);
                                    let kecamatanId = dataKecamatan.find((item) => item.nama_kecamatan === data.kecamatan).id_kecamatan;
                                    Commons.GetData(APP_HOST + '/alamat/kelurahan-kecamatan-' + kecamatanId)
                                        .then((dataKelurahan) => {
                                            setKelurahans(dataKelurahan);
                                            setIsLoadingKelurahan(false);
                                        });
                                });

                        });
                }
            })
            .catch((errResponse) => {
                console.log(errResponse);
            });
    }, []);

    return (
        <>
            <Card>
                <CardHeader title="Data Sekolah Asal" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid sx={{ marginTop: "20px", padding: "10px" }} container spacing={2}>
                        <GridForm column={6} titleForm={"Nama Sekolah Asal"} attribute={{ name: "nama_sekolah", value: data?.nama_sekolah }} isRequired={true} handleChange={handleChange}></GridForm>
                        <GridForm column={6} titleForm={"Alamat"} attribute={{ name: "alamat", value: data?.alamat, rows: 3, multiline: true }} isRequired={true} handleChange={handleChange}></GridForm>

                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} xl={6} lg={6}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Jenis Sekolah</FormLabel>
                            <Select value={data?.jenis_sekolah} name='jenis_sekolah' required onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth>
                                {
                                    Object.entries(TYPE_SEKOLAH_ASAL).map(([key, valueTK]) => {
                                        return (
                                            <MenuItem value={valueTK} key={key}>{valueTK}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <GridDdlPlace columns={6} titleForm={"Provinsi"} isRequired={true} attribute={{ name: "provinsi", value: data?.provinsi }}
                            datahandler={(e) => {
                                handleChange(e.target.name, e.target.value);
                                GetKabupaten(provinsis.find((item) => item.nama_provinsi === e.target.value).id_provinsi);
                            }} datas={{ data: provinsis, keyName: "id_provinsi", valueName: "nama_provinsi" }} isLoading={isLoadingProvinsi}></GridDdlPlace>

                        <GridForm column={6} titleForm={"NPSN (Optional)"} attribute={{ name: "npsn", value: data?.npsn }} isRequired={false} handleChange={handleChange}></GridForm>
                        <Grid sx={{ padding: "5px" }} xs={12} xl={6} lg={6} sm={12} md={6}>
                            <GridDdlPlace titleForm={"Kota/Kabupaten"} isRequired={true} attribute={{ name: "kabupaten", value: data?.kabupaten }}
                                datahandler={(e) => {
                                    handleChange(e.target.name, e.target.value);
                                    GetKecamatan(kabupatens.find((item) => item.nama_kabupaten_kota === e.target.value).id_kabupaten_kota);
                                }} datas={{ data: kabupatens, keyName: "id_kabupaten_kota", valueName: "nama_kabupaten_kota" }} isLoading={isLoadingKabupaten}></GridDdlPlace>
                            <GridDdlPlace titleForm={"Kecamatan"} isRequired={true} attribute={{ name: "kecamatan", value: data?.kecamatan }}
                                datahandler={(e) => {
                                    handleChange(e.target.name, e.target.value);
                                    GetKelurahan(kecamatans.find((item) => item.nama_kecamatan === e.target.value).id_kecamatan);
                                }}
                                datas={{ data: kecamatans, keyName: "id_kecamatan", valueName: "nama_kecamatan" }} isLoading={isLoadingKecamatan}></GridDdlPlace>
                            <GridDdlPlace titleForm={"Kelurahan"} isRequired={true} attribute={{ name: "kelurahan", value: data?.kelurahan }}
                                datahandler={(e) => {
                                    handleChange(e.target.name, e.target.value);
                                }} datas={{ data: kelurahans, keyName: "id_desa_kelurahan", valueName: "nama_desa_kelurahan" }} isLoading={isLoadingKelurahan}></GridDdlPlace>
                        </Grid>

                        <GridForm column={6} titleForm={"Tahun Lulus/Keluar"} attribute={{ name: "tahun_lulus", value: data?.tahun_lulus }} isRequired={true} handleChange={handleChange}></GridForm>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default SekolahAsal;